import { render, staticRenderFns } from "./ReservationDetail.vue?vue&type=template&id=b2782f70&scoped=true&"
import script from "./ReservationDetail.vue?vue&type=script&lang=js&"
export * from "./ReservationDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReservationDetail.vue?vue&type=style&index=0&id=b2782f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2782f70",
  null
  
)

export default component.exports